import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-neutral-900 font-sans selection:bg-neutral-800 selection:text-white">
      <ScrollToTop />
      <Navbar />

      <main className="flex-1">
        <Routes>
          {/* Forside */}
          <Route path="/" element={<Home />} />

          {/* Undersider iht. URL-struktur fra scrapet */}
          <Route path="/rottespaerre" element={<ServiceDetail explicitSlug="rottespaerre" />} />
          <Route path="/hoejvandslukke" element={<ServiceDetail explicitSlug="hoejvandslukke" />} />
          <Route path="/kloak-tv" element={<ServiceDetail explicitSlug="kloak-tv" />} />
          <Route path="/punktreparation" element={<ServiceDetail explicitSlug="punktreparation" />} />
          <Route path="/spuling-slamsugning" element={<ServiceDetail explicitSlug="spuling-slamsugning" />} />
          <Route path="/raad-mod-rotter" element={<ServiceDetail explicitSlug="raad-mod-rotter" />} />
          <Route path="/om-fyns-afloebsteknik" element={<ServiceDetail explicitSlug="om-fyns-afloebsteknik" />} />

          {/* Kontaktside */}
          <Route path="/kontakt" element={<Contact />} />

          {/* Fejlsider (403 og 404) */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
